import React ,{useEffect,useState,useRef} from 'react';
import Swiper from 'react-id-swiper';
import "./sections.scss";
import {getMallCats_api} from "../../../Services/apis";
import {useHistory} from "react-router-dom";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

function CategorySliderSec({item}) {

    const [cats,setCats] = useState([])
    const [catSwitch,set_catSwitch] = useState(false)
    const history = useHistory()
    const ref = useRef(null);

    const clickOnItem = (item)=>{
        if(item)
            history.push("/store",{catLink:item})
    }

    useEffect(()=>{
       // getCats();
        getCatsFromItems()
        // Loop()
    },[])

    const Loop = ()=>{
        setInterval(()=>{
            try{
                ref.current.swiper.slideNext();
            }catch (e) {
                // console.log(e)
            }
        },6000)
    }

    const goNext = ()=>{
        ref.current.swiper.slideNext()
    }
    const goPrev = ()=>{
        ref.current.swiper.slidePrev()
    }


    const getCats = async()=>{
        try{
            const res= await getMallCats_api();
            let chunks = chunkCats(res.data);
            setCats(chunks)
            set_catSwitch(true)
        }catch (e) {
            console.log("e")
        }
    }

    const getCatsFromItems = ()=>{
        let chunks = chunkCats(item.items.reverse());
        setCats(chunks)
        set_catSwitch(true)
        setTimeout(() => {
            amendSlider()
        },1000)

    }

    const chunkCats = (list)=>{
        const perChunk = 6 // items per chunk
        const inputArray = list
        const result = inputArray.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index/perChunk)
            if(!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = []
            }
            resultArray[chunkIndex].push(item)
            return resultArray
        }, [])
        return result;
    }

    const params = {
        direction: 'horizontal',
        // loop: true,
    }

    const amendSlider = ()=>{
        set_catSwitch(false)
        setTimeout(() => {
            set_catSwitch(true)
        },3000)
    }


    return(
        <>
            <div className="handle-slider" style={{position: 'relative',margin:"20px 16px 0 16px"}}>
                {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
                {catSwitch?<Swiper ref={ref} {...params}>
                    {cats?.map(c=>{
                        return(
                            <div className="cat_slider_item">
                                <div className="cat_slider_item_row">
                                    <div className="cat_slider_item_cat"
                                        // onClick={e=>clickOnItem(c[0]?.uid)}
                                         onClick={e=>clickOnItem(c[0]?.link_to_uid)}

                                    >
                                        <span>{c[0]?.title}</span>
                                        <img src={c[0]?.image} alt=""/>
                                    </div>
                                    <div className="cat_slider_item_cat" onClick={e=>clickOnItem(c[1]?.link_to_uid)}>
                                        <span>{c[1]?.title}</span>
                                        <img src={c[1]?.image} alt=""/>
                                    </div>
                                    <div className="cat_slider_item_cat" onClick={e=>clickOnItem(c[2]?.link_to_uid)}>
                                        <span>{c[2]?.title}</span>
                                        <img src={c[2]?.image} alt=""/>
                                    </div>
                                </div>
                                <div className="cat_slider_item_row">
                                    <div className="cat_slider_item_cat" onClick={e=>clickOnItem(c[3]?.link_to_uid)}>
                                        <span>{c[3]?.title}</span>
                                        <img src={c[3]?.image} alt=""/>
                                    </div>
                                    <div className="cat_slider_item_cat" onClick={e=>clickOnItem(c[4]?.link_to_uid)}>
                                        <span>{c[4]?.title}</span>
                                        <img src={c[4]?.image} alt=""/>
                                    </div>
                                    <div className="cat_slider_item_cat" onClick={e=>clickOnItem(c[5]?.link_to_uid)}>
                                        <span>{c[5]?.title}</span>
                                        <img src={c[5]?.image} alt=""/>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </Swiper>:null}
                <div className="cat-slider-handle">
                    <div className="cat-slider-handle-left" onClick={e=>goPrev()}><LeftOutlined /></div>
                    <div className="cat-slider-handle-right" onClick={e=>goNext()}><RightOutlined /></div>
                </div>

            </div>
            </>

    )
}

export default CategorySliderSec;
